module.exports = __webpack_public_path__ + "img/mobile-money.8150a6f6.png";